/**
 * 导入工具模块
 */
import { isInApp, isValidJSON } from '../utils/index';

/**
 * 导入handler
 */
import { bridgeCallHandler, bridgeRegisterHandler } from './index';

/**
 * 注册返回监听事件
 * @param callback
 */
export function setEventWatchCloseWebview(callback: () => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端注册返回监听事件');
    return;
  }

  bridgeRegisterHandler('addEventListenerCloseWebview', '', callback);
}

/**
 * 调用客户端主题变化事件
 * @param callback
 * @returns
 */
export function setEventWatchThemeChange(callback: BridgeResponseCallback): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端主题变化事件');
    return;
  }

  bridgeRegisterHandler('setTheme', '', callback);
}

/**
 * 注册更新页面方法
 * @param callback
 */
export function setEventWatchUpdate(eventName: string, callback: (val: any) => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端注册更新页面方法');
    return;
  }

  /**
   * 注册页面更新的handler
   */
  bridgeRegisterHandler('refreshPage', '', (val: string | undefined | null) => {
    if (!val) {
      return;
    }

    /**
     * 获取返回参数
     */
    let data: BridgeUpdateOptions = isValidJSON(val) ? JSON.parse(val) : {};

    /**
     * 触发回调
     */
    if (data.type == 'get' && callback) {
      callback(data.data);
    }
  });

  /**
   * 标记当前更新的标识
   */
  let setData: BridgeUpdateOptions = {
    type: 'set',
    key: eventName,
    data: '',
  };
  let params = JSON.stringify(setData);
  bridgeCallHandler('toRefreshPage', params, null);
}

/**
 * 注册多选图片回调监听事件
 * @param callback
 */
export function setEventWatchMultiChooseImage(callback: (data: string) => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('调用客户端注册多选图片回调监听事件');
    return;
  }

  bridgeRegisterHandler('chooseImageMultiCallBack', '', callback);
}

/**
 * 监听键盘显示隐藏事件，并返回键盘高度
 * @param callback
 * @returns
 */
export function setEventWatchKeyboardVisibilityChange(callback: (data: BridgeResponse) => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('监听键盘显示隐藏事件，并返回键盘高度');
    callback(0);
    return;
  }

  bridgeRegisterHandler('keyboardVisibilityChange', '', callback);
}

/**
 * 监听原生触发提问事件
 * @param callback
 */
export function triggerAIQuestion(callback: (data: BridgeResponse) => void): void {
  let isApp: boolean = isInApp();

  if (!isApp) {
    console.warn('监听原生触发提问事件');
    return;
  }

  bridgeRegisterHandler('triggerAIQuestion', '', callback);
}

/**
 * 注册自选股更新方法
 * @param callback
 */
export function setEventWatchSelfStockChange(callback: (data: string) => void): void {
  let isApp: boolean = isInApp();
  if (!isApp) {
    console.warn('调用客户端注册自选股更新方法');
    return;
  }
  bridgeRegisterHandler('reloadSelfStocks', '', callback);
}
